import FilevineIcon from './FilevineIcon';

export default FilevineIcon;
